import type { UIEvent } from "react"

import type { TranslationObj } from "$/utils/lang"

import { ETypographyColor, ETypographySize } from "@/3514/components/shared/typography/typography.types"
import type { IModuleExcerptAssociatedSessionModel, IModuleExcerptPhaseBaseModel } from "@/3514/types"

type TModuleExcerptPhase = IModuleExcerptPhaseBaseModel & { order: number }

enum EModuleExcerptMode {
    Full = "Full",
    View = "View"
}

enum EModuleExcerptVariant {
    Full = "Full",
    Cropped = "Cropped"
}

enum EModuleExcerptRsvpButtonPosition {
    Inside = "Inside",
    Outside = "Outside"
}

type TModuleExcerptModuleUiModel = {
    rank: number
    id: number
    session: IModuleExcerptAssociatedSessionModel
    phases: TModuleExcerptPhase[]
    name?: TranslationObj
    isStub?: boolean
}

type TModuleExcerptUiModel = {
    // api part
    module: TModuleExcerptModuleUiModel
    // ui part
    variant?: EModuleExcerptVariant
    mode?: EModuleExcerptMode
    rsvpButtonPosition?: EModuleExcerptRsvpButtonPosition
    containerClassName?: string
    wrapperClassName?: string
    isLastOrdered?: boolean
    isCurrentModule?: boolean
    withPaddings?: boolean
    withBottomBorder?: boolean
    titleSize?: ETypographySize
    titleColor?: ETypographyColor
    handleSessionAction?(event: UIEvent, sessionId: number): void
}

export type { TModuleExcerptPhase, TModuleExcerptModuleUiModel, TModuleExcerptUiModel }
export { EModuleExcerptMode, EModuleExcerptVariant, EModuleExcerptRsvpButtonPosition }
